module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }